import { http } from '@/http/index.js';
import { createRouter, createWebHashHistory } from 'vue-router';
// import { getAuthentication } from '@hitools/utils'
import {i18n} from '@/i18n/index';

const routes = [
  {
    path: '/',
    // redirect: 'ProjectManage',
    name: 'index',
    component: () => import('@/views/index.vue'),
  },
  {
    path: '/platform',
    name: 'platform',
    component: () => import('@/views/platform/platform.vue'),
  },
  {
    path: '/ProjectManage',
    name: 'ProjectManage',
    component: () => import('@/views/ProjectManage/ProjectManage.vue'),
  },
  {
    path: '/no-auth',
    name: 'NoAuth',
    component: () => import('@/views/errorPage/noAuth.vue'),
  },
  {
    path: '/ProjectDetail',
    name: 'ProjectDetail',
    component: () => import('@/views/ProjectDetail/ProjectDetail.vue'),
  },
  {
    path: '/ExportSolution',
    name: 'ExportSolution',
    component: () => import('@/views/ExportSolution/ExportSolution.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory('/'),
  routes: routes,
});
const parseQueryString = (queryString) => {
  const params = new URLSearchParams(queryString);
  const parsed = {};

  for (const [key, value] of params.entries()) {
    parsed[key] = value;
  }

  return parsed;
}
// 判断用户是否已经登录
router.beforeEach(async (to, from, next) => {
  console.log(to)
  console.log(from)
  // 海外特有 本地调试取消鉴权
  if (to.name === 'NoAuth' || to.name === '404') {
    return next()
  }
  if (to.fullPath.includes('/platform')) {
    const url = window.location.href
    const queryString = url.substring(url.indexOf('?') + 1)
    const parsed = parseQueryString(queryString)
    sessionStorage.setItem('scenario', parsed.scenario) // 场景     "1"
    sessionStorage.setItem('userName', parsed.userName) // 用户名     "1"
    sessionStorage.setItem('language', parsed.language) // 多语言     "en"
    sessionStorage.setItem('country', parsed.country) // 国家       "SA"
    i18n.global.locale.value = parsed.language;
    const loginInfo = await http.get('/Common/user/authentication', {
      params: parsed,
    }, {
      bNotAddPre: true
    });
    if (loginInfo?.sessionKey && loginInfo?.uuid) {
      // 登录成功,将当前的授权信息进行存储
      // 将对应的授权信息存储
      sessionStorage.setItem('Authorization', loginInfo.sessionKey);
      sessionStorage.setItem('uuid', loginInfo.uuid)
      await http.get('/UserAuth/User', null, {
        bNotAddPre: true
      });
      next({name: 'ProjectManage'})
    } else {
      window.location.href = 'https://www.hik-partner.com'
    }
  }
  next()
})

export default router;
